import  footerComponent from './footer.vue'

const  vfooter={
  install:function (Vue) {
    Vue.component('v-footer',footerComponent)
  }
}

export  default vfooter;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js